import React from 'react';

function BlogLink(props) {
  return <a target='_blank' className="blog-grad-link" {...props} />;
}

export default BlogLink;
